class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.generateNavigationMenu();
  }

  renderLinkIcon(node) {
    const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const iconPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );

    iconSvg.setAttribute('fill', 'none');
    iconSvg.setAttribute('width', 7);
    iconSvg.setAttribute('height', 11);
    iconSvg.setAttribute('viewBox', '0 0 7 11');
    iconSvg.setAttribute('stroke', '#AC8544');

    iconPath.setAttribute(
      'd',
      'M0.700195 10.3461L5.46136 6.03836L0.700195 1.50391'
    );
    iconPath.setAttribute('stroke-width', '1.5');

    iconSvg.appendChild(iconPath);

    return node.appendChild(iconSvg);
  }

  generateNavigationMenu() {
    const headings = Array.from(this.querySelectorAll('h2'));

    if (headings.length === 0) {
      console.warn('Keine Absätze vorhanden');
      return;
    }

    const navList = document.createElement('ul');
    const navParent = this.querySelector('.ds-content-navigation')

    let counter = 0
    headings.forEach((heading) => {
      const headingId = `nav-${counter}`
      heading.id = headingId
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      this.renderLinkIcon(listItem)
      anchor.textContent = heading.textContent.trimStart();
      anchor.href = `#${heading.id}`;
      listItem.appendChild(anchor);
      navList.appendChild(listItem);
      counter++
    });

    navParent.appendChild(navList);
  }
}

if (!window.customElements.get("collection-description")) {
  customElements.define('collection-description', CollectionDescription);
}